import { fromJS } from 'immutable';

const initialState = fromJS({
	open: false,
});

export default function addProductToContractDialog(state = initialState, { type, payload }) {
	switch (type) {
		case 'CHANGE_ADD_PRODUCT_TO_CONTRACT_DIALOG_STATE':
			return state.set('open', payload);
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/app/stores/contracting/dialogs/dialog-reducers/add-product-to-contract-dialog.js